// X-axis label sizing for the Summary Plot: a time label ("12:30 PM" at 12px)
// plus the gap that keeps neighbours from touching, and the width one y-axis
// takes away from the plot area.
const LABEL_WIDTH = 78
const AXIS_GUTTER = 85
const MIN_PLOT_WIDTH = 120
// Only used if the container reports no width (never rendered / display:none).
const FALLBACK_WIDTH = 900

// Label one slot in every `stride` on the x-axis — enough that two labels can
// never touch at this width. ApexCharts' own hideOverlappingLabels can't be
// relied on: it compares each label's CENTRE against the FULL width of the
// previously drawn one, so as soon as a narrow label ("1:30 PM") is drawn every
// following one clears the test and the 30-minute slots run together
// ("1:30 PM2:00 PM2:30 PM").
export const getLabelStride = (width: number, slots: number, visibleLineAxes: number) => {
  // Plot area ≈ the card minus the headcount axis on the left and one axis per
  // visible line on the right.
  const plotWidth = Math.max(
    MIN_PLOT_WIDTH,
    (Number.isFinite(width) && width > 0 ? width : FALLBACK_WIDTH) -
      AXIS_GUTTER * (1 + visibleLineAxes)
  )
  const slotWidth = plotWidth / Math.max(1, slots)
  return Math.max(1, Math.ceil(LABEL_WIDTH / slotWidth))
}

// The stride has to be expressed as an xaxis.tickAmount, which is the only
// label-thinning knob that works on this build: ApexCharts' dist calls
// xaxis.labels.formatter with the value ALONE (no index, no opts), whatever the
// src/ in the same package says, so a formatter cannot tell which slot it is
// labelling. ApexCharts turns tickAmount into `Math.round(slots / (ticks + 1))`
// slots per label, so invert that to land on the stride we want.
// chartAxisApex.test.ts pins this against the real library.
export const tickAmountForStride = (slots: number, stride: number) =>
  Math.max(1, Math.round(Math.max(1, slots) / Math.max(1, stride)) - 1)

export const getAxisTickAmount = (width: number, slots: number, visibleLineAxes: number) =>
  tickAmountForStride(slots, getLabelStride(width, slots, visibleLineAxes))
